import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const FullWidthSliceWrapper = styled.div``;

export const NarrowSliceWrapper = styled.div`
  max-width: ${theme.maxWidth};
  margin: 0 auto;
  padding: 0 ${theme.spacing[4]};

  ${theme.largerThan.xl} {
    padding: 0;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
`;
